module.exports = __webpack_public_path__ + "static/media/back-purple.6e4d9491.png";